import { Component, Inject, Optional } from '@angular/core';
import {
  MAT_DIALOG_DATA,
  MatDialogRef,
  MatDialogTitle,
  MatDialogContent,
} from '@angular/material/dialog';
import { SafeHtml } from '@angular/platform-browser';
import {
  copyTextToClipboard,
  getPinWithEdition,
  isAndroid,
  isIOS,
} from 'src/app/utility/app.utils';
import { UtilityService } from 'src/app/utility/utility.service';
import { environment } from 'src/environments/environment';
import { MatIconButton } from '@angular/material/button';
import { MatIcon } from '@angular/material/icon';
import { CdkScrollable } from '@angular/cdk/scrolling';

import { TranslateModule } from '@ngx-translate/core';
import { QrCodePreviewComponent } from '../qr-code-preview/qr-code-preview.component';

export interface AppSwitchDialogData {
  qrSVG: SafeHtml;
  pinCode: string;
  contentUrl?: string;
}

@Component({
  selector: 'qa-app-switch-dialog',
  templateUrl: './app-switch-dialog.component.html',
  styleUrl: './app-switch-dialog.component.scss',
  imports: [
    MatDialogTitle,
    MatIconButton,
    MatIcon,
    CdkScrollable,
    MatDialogContent,
    TranslateModule,
    QrCodePreviewComponent,
  ],
})
export class AppSwitchDialogComponent {
  isIOS = isIOS;
  isAndroid = isAndroid;

  androidLink: string;
  iosLink: string;

  pinCode: string;
  editionPrefix: string;

  constructor(
    @Optional() public dialogRef: MatDialogRef<AppSwitchDialogComponent>,
    @Optional() @Inject(MAT_DIALOG_DATA) public data: any,
    private utilityService: UtilityService
  ) {
    this.androidLink = environment.playStoreLink;
    this.pinCode = this.data.pinCode;
    if (this.data.contentUrl) {
      this.androidLink = `${this.androidLink}&referrer=${encodeURIComponent(
        this.data.contentUrl
      )}`;
    }
    this.iosLink = environment.appStoreLink;
    this.editionPrefix = this.utilityService.getEditionPrefixFromPath();
  }

  openLink(appLink: string) {
    if (this.data.contentUrl) {
      copyTextToClipboard(this.data.contentUrl);
    }
    window.open(appLink, '_blank');
    this.dialogRef.close();
  }

  copyPin() {
    this.utilityService.copyPin(getPinWithEdition(this.pinCode));
  }
}
